// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { createWidgetizedHelpPanel } from './implementation';

export const InternalHelpPanel = createWidgetizedHelpPanel();
